import {
  GET_HEAT_MAP_DATA_FAILURE,
  GET_HEAT_MAP_DATA_REQUEST,
  GET_HEAT_MAP_DATA_SUCCESS,
  GET_HEATMAP_FOR_EXPOSURES_FAILURE,
  GET_HEATMAP_FOR_EXPOSURES_REQUEST,
  GET_HEATMAP_FOR_EXPOSURES_SUCCESS,
  GET_HEATMAP_FOR_IMPRESSIONS_FAILURE,
  GET_HEATMAP_FOR_IMPRESSIONS_REQUEST,
  GET_HEATMAP_FOR_IMPRESSIONS_SUCCESS,
} from './reportConstants';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  getHeatMapData,
  getHeatmapForExposures,
  getHeatmapForImpressions,
} from './reportService';

function* getHeatMapDataSaga(action) {
  const { campaignId, pixelId } = action.payload;
  try {
    const response = yield call(getHeatMapData, campaignId, pixelId);
    yield put({ type: GET_HEAT_MAP_DATA_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: GET_HEAT_MAP_DATA_FAILURE, payload: error });
  }
}
function* getHeatmapForImpressionsSaga(action) {
  const { pixelId, campaignId, start, end } = action.payload;
  try {
    const response = yield call(
      getHeatmapForImpressions,
      pixelId,
      campaignId,
      start,
      end
    );
    yield put({
      type: GET_HEATMAP_FOR_IMPRESSIONS_SUCCESS,
      data: response.data,
    });
    yield put({
      type: GET_HEAT_MAP_DATA_REQUEST,
      payload: { ...action.payload, data: response.data.id },
    });
  } catch (error) {
    yield put({
      type: GET_HEATMAP_FOR_IMPRESSIONS_FAILURE,
      error,
    });
  }
}
function* getHeatmapForExposuresSaga(action) {
  const { pixelId, campaignId, start, end } = action.payload;
  try {
    const response = yield call(
      getHeatmapForExposures,
      pixelId,
      campaignId,
      start,
      end
    );
    yield put({
      type: GET_HEATMAP_FOR_EXPOSURES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: GET_HEATMAP_FOR_EXPOSURES_FAILURE, payload: error });
  }
}

export function* GET_HEAT_MAP_DATA_SAGA() {
  yield takeEvery(GET_HEAT_MAP_DATA_REQUEST, getHeatMapDataSaga);
  yield takeEvery(
    GET_HEATMAP_FOR_IMPRESSIONS_REQUEST,
    getHeatmapForImpressionsSaga
  );
  yield takeEvery(
    GET_HEATMAP_FOR_EXPOSURES_REQUEST,
    getHeatmapForExposuresSaga
  );
}
